import memoize from 'lodash/memoize';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import {
  AUTOCOMPLETE,
  FINDADDRESS,
  GET_FORMATTED_ADDRESS,
  SELECTADDRESS,
  VALIDATEPOSTCODE,
} from '../config/setup/setup';
import ErrorTrackingService from './errorTrackingService';
import httpCommonHeaders from './httpCommonHeaders';

export const findAddress = async (postCode) => {
  const url = `${FINDADDRESS.replace('##POSTCODE##', postCode)}`;

  try {
    return await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    ErrorTrackingService.logError(error);

    return null;
  }
};

export const selectAddressByMoniker = async (moniker) => {
  const url = `${SELECTADDRESS.replace('##MONIKER##', moniker)}`;

  try {
    return await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    console.error(error);
    ErrorTrackingService.logError(error);

    return null;
  }
};

export const autocomplete = async (address) => {
  const url = `${AUTOCOMPLETE}`;
  const searchBody = {
    addressSearch: {
      typeDownAddress: address,
    },
  };

  try {
    return await axios({
      cache: false,
      data: JSON.stringify(searchBody),
      headers: httpCommonHeaders(),
      method: 'POST',
      url,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    ErrorTrackingService.logError(error);

    return null;
  }
};

export const selectAddressByAddressKey = async (addressKey) => {
  const url = `${GET_FORMATTED_ADDRESS.replace(
    '##GLOBALADDRESSKEY##',
    addressKey,
  )}`;

  try {
    return await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    console.error(error);
    ErrorTrackingService.logError(error);

    return null;
  }
};

export const _verifyPostcode = async (postCode) => {
  const url = `${VALIDATEPOSTCODE.replace('##POSTCODE##', postCode)}`;

  if (!postCode || postCode?.length < 5) return null;

  try {
    const response = await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });
    if (!response) return false;

    return response?.status === (200 || 202);
  } catch (error) {
    ErrorTrackingService.logError(error);

    return false;
  }
};

/** Valdate postcode by lookup via experian
 *
 * @async
 * @param {string} postCode - The postcode to validate
 * @returns {boolean}
 */
export const verifyPostcode = memoize(_verifyPostcode);
